<template>
  <PodcastPaywall :podcast="context">
    <template #active>
      <SingleColumn>
        <template #header>
          <section class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-3xl font-bold text-white">
                Experimente
              </h1>
            </div>
            <div class="mt-5 flex justify-center sm:mt-0">
              <router-link :to="{name: 'experiments.create'}" class="button-create mr-4">
                <BeakerIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                <span class="ml-3">
                  Neues Experiment starten
                </span>
              </router-link>
            </div>
          </section>
        </template>
        <template #content>
          <section v-if="empty">
            <div class="bg-white shadow overflow-hidden sm:rounded-lg">
              <div class="px-4 py-5 sm:px-6">
                <p class="mt-1 max-w-2xl text-sm text-gray-500">
                  Du hast bisher noch keine Experimente gestartet. Lass dich inspirieren, was dir die 🧭 Kompass-KI als Nächstes empfiehlt.
                </p>
              </div>
            </div>
          </section>
          <section v-else="empty">
            <div v-if="running.length > 0">
              <div class="space-y-8">
                <ExperimentCard v-for="e in running" :key="e.id" :experiment="e" />
              </div>
            </div>
            <div v-else>
              <div class="bg-white shadow overflow-hidden sm:rounded-lg">
                <div class="px-4 py-5 sm:px-6">
                  <p class="mt-1 max-w-2xl text-sm text-gray-500">
                    Alle Experimente sind beendet. Aktualisiere jetzt deine Metriken oder lass dich inspirieren, was dir die 🧭 Kompass-KI als Nächstes empfiehlt.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="pt-8">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-xl font-bold text-gray-700 mb-4">
                Abgelaufene Experimente
              </h1>
            </div>
            <div v-if="expired.length > 0">
              <div class="space-y-8">
                <ExperimentCard v-for="e in expired" :key="e.id" :experiment="e" />
              </div>
            </div>
            <div v-else>
              <p class="mt-4 max-w-2xl text-sm text-gray-500">
                Du hast noch keine abgelaufenen Experimente.
              </p>
            </div>
          </section>
        </template>
      </SingleColumn>
    </template>
    <template #inactive>
      <SingleColumn>
        <template #header>
          <section class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-3xl font-bold text-white">
                Experimente sind Teil vom Studio Pro
              </h1>
            </div>
          </section>
        </template>
        <template #content>
          <ConversionTrigger :podcast="context" />
        </template>
      </SingleColumn>
    </template>
  </PodcastPaywall>
</template>

<script setup>
import { computed, watch, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useFetchResources } from '@/client/actions';

const store = useStore();
const context = computed(() => store.getters['context/context']);
const parent = computed(() => store.getters['context/context'].id);
const target = computed(() => '/api/podcasts/' + parent.value + '/experiments');
const action = useFetchResources(target);

const { results, fetching, fetch, empty } = action;

const running = computed(() => results.value.filter(e => ! e.has_ended));
const expired = computed(() => results.value.filter(e => e.has_ended));

const mounted = onMounted(() => fetch());
const watcher = watch(target, (v, _) => fetch());
</script>

<style scoped>
.button-create
{
  @apply flex justify-center items-center px-4 py-2;
  @apply border border-gray-300 shadow-sm;
  @apply text-sm font-medium rounded-md text-gray-700;
  @apply bg-white hover:bg-gray-50;
}
</style>
